import { Typography, Grid, useMediaQuery, useTheme, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { keyframes } from '@mui/system';
import SplashScreenMobile from '../../SignUp/SplashScreenMobile';
import SplashScreen from '../../SignUp/SplashScreen';
import './LoadingDots.css';
import Logo from '../../Common/Logo';

const slideInSun = keyframes`
  from {
    width: 56px;
    height: 56px;
  }
  to {
    width: 86px;
    height: 86px;
  }
`;

function CoachOnboardingLoading() {
  const { t } = useTranslation();
  const theme = useTheme();

  const currentYear = new Date().getFullYear();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Grid
      display="flex"
      flexDirection="column"
      alignItems="center"
      minHeight="100vh"
      sx={{
        background: 'linear-gradient(163deg, #FFF 10.13%, #FFF4F0 89.18%)',
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
        height: '100%',
      }}
    >
      <Grid
        pt={4}
        pb={1}
        container
        alignItems="center"
        justifyContent="space-between"
        flexDirection="column"
        height="100vh"
        width={374}
      >
        <Grid height={86}>
          <Box sx={{ animation: `${slideInSun} 3s ease forwards` }}>
            <Logo />
          </Box>
        </Grid>
        <Grid item container flexDirection="column">
          <Typography
            variant="title2Bold"
            textAlign="center"
            color="primary"
            display="flex"
            alignItems="end"
          >
            {t('therapistOnboarding.loadingScreen.title')}
            <div className="dotsLoader" />
          </Typography>
          <br />
          <Typography variant="bodyRegular" textAlign="center" color="primary">
            {t('therapistOnboarding.loadingScreen.description1')}
          </Typography>
          <br />
          <Typography variant="bodyRegular" textAlign="center" color="primary">
            {t('therapistOnboarding.loadingScreen.description2')}
          </Typography>
        </Grid>
        <Typography
          variant="caption2Regular"
          textAlign="center"
          color="primary"
          marginBottom="10px"
        >
          {currentYear} ProgressMagic. {t('common.allRightsReserved')}
        </Typography>
      </Grid>

      {isSmallScreen ? <SplashScreenMobile /> : <SplashScreen />}
    </Grid>
  );
}

export default CoachOnboardingLoading;
